export { default } from 'cccisd-game-lionsquest';
